import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';
import TextSwiper from './TextSwiper';
import stage from './Stage';
import TextPositionIndicator from './TextPositionIndicator';


class TextFrame extends RenderContainer {
  constructor(text, pageIndex) {
    super();
    this.name = 'NextButton';
    this.imageName = 'frame';
    this.bitmap = null;
    this.label = null;
    this.text = text;
    this.pageIndex = pageIndex;
    loader.addItems(this, [this.imageName]);

    this.maxWidth = 0.8 * 0.8;
    this.maxHeight = 0.25 * 0.8;
    const size = globals.relSizeToScreen({
      x: this.maxWidth,
      y: this.maxHeight
    });
    this.width = size.x;
    this.height = size.y;

    this.relX = 0.5;
    // Y position allows for showing the object completely
    this.relY = this.maxHeight / 2.0;
    const pos = globals.relToScreen({ x: this.relX, y: this.relY });
    this.x = pos.x;
    this.y = pos.y;

    this.render.stream = false;

    this.textPositionIndicator = new TextPositionIndicator(this.pageIndex);
    stage.on('ShowText', this.moveDown, this);
    stage.on('HideText', this.moveUp, this);
    stage.on('HideTextInstant', this.hide, this);
    stage.on('ShowTextInstant', this.show, this);

    stage.on(`NextTextBtnPressPage${this.pageIndex}`, this.moveTextForward, this);
    stage.on(`PreviousTextBtnPressPage${this.pageIndex}`, this.moveTextBackward, this);

    this.totalDistance = this.bookLength * globals.width;
    this.currentDistance = 0;
    this.startDrag = 0;

    this.locations = [];
    this.index = 0;
  }

  homeText() {
    if (this.swiper) {
      this.swiper.home();
    }
  }

  populateUpDownPositions() {
    this.downPos = {};
    this.downPos.x = this.x;
    this.downPos.y = this.y;
    this.upPos = {};

    this.upPos.x = this.x;
    this.upPos.y = -this.y - this.height;
  }

  moveUp() {
    this.render.stream = true;
    createjs.Tween.get(this, { override: true })
      .to({ y: this.upPos.y }, 500, createjs.Ease.quadOut)
      .call(() => {
        this.render.stream = false;
      });
  }

  moveDown() {
    this.render.stream = true;
    createjs.Tween.get(this, { override: true })
      .to({ y: this.downPos.y }, 500, createjs.Ease.quadOut)
      .call(() => {
        this.render.stream = false;
      });
  }

  hide() {
    this.visible = false;
  }
  show() {
    this.visible = true;
  }

  populateText() {
    // Text smaller than half frame height to give nice padding
    this.label = new createjs.Text(
      this.text,
      `${this.height / this.scaleY * 0.30}px MerriWeatherRegular`
    );
    this.label.textBaseline = 'middle';

    /* Determines the clip mask, and the text x-starting
    position in percent of frame width */
    const distFromSides = 0.03;
    const distFromHorizEdges = 0.1;

    this.label.x += (distFromSides * this.width) / this.scaleX;
    this.label.y += (0.4 * this.height) / this.scaleY;

    // Create masking container
    this.textBox = new RenderContainer();
    const shape = new createjs.Shape();

    const rectLX = (distFromSides * this.width) / this.scaleX;
    const rectLY = (distFromHorizEdges * this.height) / this.scaleY;
    const rectWidth = ((1 - distFromSides) * this.width) / this.scaleX - rectLX;
    const rectHeight = ((1 - distFromHorizEdges) * this.height) / this.scaleY - rectLY;

    shape.rectWidth = rectWidth;
    shape.graphics
      .beginFill('#ff0000')
      .drawRect(rectLX, rectLY, rectWidth, rectHeight)
      .s('#ff0000');
    this.hitArea = shape;
    this.textBox.mask = shape;
    this.textBox.addChild(this.label);
    this.addChild(this.textBox);
  }

  addSwiper() {
    // Loads a swiper to suit the text width
    /* Calculates the minimum full banner width swipes of text
    then averages this movement for seemless progression */

    // Get the inside text horiz distance
    const textBoxWidth = this.textBox.mask.rectWidth;
    this.swipeDistance = textBoxWidth * 0.7
    const textWidth = this.label.getBounds().width;
    const textOffset = this.label.x;
    const textDistanceRatio = textWidth / this.swipeDistance;
    const swipeSteps = Math.max(1, textDistanceRatio) * 1.3 - 0.77;
    
    for (let i = 0; i < swipeSteps; i += 1) {
       this.locations.push(-textOffset + i * this.swipeDistance);
    }

    this.swipeSteps = swipeSteps;
    // Initialises the swiper
    // adds a callback to stop rendering on complete
    this.swiper = new TextSwiper(
      this,
      this.label,
      this.locations,
      () => {
        this.render.stream = false;
        this.updateTextPositionIndicator();
      },
      this.pageIndex
    );

    // Allows re-rendering on a drag event
    this.on('pressmove', () => {
      this.render.stream = true;
    });
  }

  updateTextPositionIndicator() {
    const { index } = this.swiper.currentPos;
    this.textPositionIndicator.moveDarkDotTo(index);
  }

  populateBanner() {
    // Grab banner image
    const tag = loader.getItem(this.imageName);
    this.bitmap = new createjs.Bitmap(tag);
  }

  loaded() {
    this.render.once = true;
    this.render.stream = false;

    if (this.text !== '') {
      this.visible = true;
      const tag = loader.getItem(this.imageName);
      this.clipImageSizeToSize(tag);

      this.populateBanner();
      this.centerOnSelf();
      this.populateText();

      this.addChild(this.bitmap);
      this.addChild(this.textBox);

      this.addSwiper();
      this.textPositionIndicator.populateDots(this.swipeSteps);
      this.addChildAt(this.textPositionIndicator, 2);
      this.textPositionIndicator.x = this.width / 2.0 / this.scaleX;
      this.textPositionIndicator.y = (0.70 * this.height) / this.scaleY;
      if (this.swipeSteps <= 1) {
        this.textPositionIndicator.visible = false;
      }
    } else {
      this.visible = false;
    }
    this.populateUpDownPositions();
  }

  moveTextForward() {
    this.swiper.initDrag({ stageX: 0, stopPropagation: () => {} });
    this.swiper.drag({ stageX: -100, stopPropagation: () => {} });
    this.swiper.finishDrag({ stopPropagation: () => {} });
    this.render.stream = true;
    this.updateTextPositionIndicator();
  }

  moveTextBackward() {
    this.swiper.initDrag({ stageX: 0, stopPropagation: () => {} });
    this.swiper.drag({ stageX: 100, stopPropagation: () => {} });
    this.swiper.finishDrag({ stopPropagation: () => {} });
    this.render.stream = true;
    this.updateTextPositionIndicator();
  }
}

export { TextFrame as default };
